import React from 'react'
import PropTypes from 'prop-types'
import { IntroMain, IntroTitle } from './index.style'
import RichText from '@components/RichText'
import Container from '@components/Container'
import Spacer from '@components/Spacer'

const Intro = ({ title }) => {
  return (
    <IntroMain>
      <Spacer size={[120, 200]} />
      <Container>
        <IntroTitle>
          <RichText
              content={title}
              paragraphSize="heading2Serif"
              maxWidth={28}
              offset="1em"
              buildOn
          />
        </IntroTitle>
      </Container>

      <Spacer size={[90, 290]} />
    </IntroMain>
  )
}

Intro.propTypes = {
  title: PropTypes.object
}

export default Intro
